import React from "react";
import { useNavigate } from "react-router-dom";
import { FaChevronRight, FaFilePdf } from "react-icons/fa";

interface PdfLessonHeaderProps {
  chapterLesson: string | null;
  className?: string;
}

const PdfLessonHeader: React.FC<PdfLessonHeaderProps> = ({
  chapterLesson,
  className = "",
}) => {
  const navigate = useNavigate();

  const handlePdfClick = () => {
    if (chapterLesson) {
      // Navigate to PDF viewer page with the lesson URL
      navigate("/pdf-view", { state: { lessonUrl: chapterLesson } });
    }
  };

  if (!chapterLesson || chapterLesson.trim() === "") {
    return null;
  }

  return (
    <button
      className={`pdf-lesson-header ${className}`}
      onClick={handlePdfClick}
      type="button"
      aria-label="Open PDF lesson"
    >
      <div className="pdf-lesson-content">
        <div className="pdf-icon-wrapper">
          <FaFilePdf className="pdf-icon" />
        </div>
        <span className="pdf-text">পিডিএফ লেসন</span>
      </div>
      <FaChevronRight className="forward-icon" size={32} />
    </button>
  );
};

export default PdfLessonHeader;
